"use strict";

import { retailSalesConstants } from "../_constants";

export const retailSalesGetWinnersRequest = (payload) => {
     return {
          type: retailSalesConstants.RETAIL_SALES_GET_WINNERS_REQUEST,
          payload,
     };
};

export const retailSalesGetWinnersComplete = (payload) => {
     return {
          type: retailSalesConstants.RETAIL_SALES_GET_WINNERS_COMPLETE,
          payload,
     };
};

export const retailSalesGetActivationReportRequest = (payload) => {
     return {
          type: retailSalesConstants.RETAIL_SALES_GET_ACTIVATION_REPORT_REQUEST,
          payload,
     };
};

export const retailSalesGetActivationReportComplete = (payload) => {
     return {
          type: retailSalesConstants.RETAIL_SALES_GET_ACTIVATION_REPORT_COMPLETE,
          payload,
     };
};

export const retailSalesGetActivationReportExportRequest = (payload) => {
     return {
          type: retailSalesConstants.RETAIL_SALES_GET_ACTIVATION_REPORT_EXPORT_REQUEST,
          payload,
     };
};

export const retailSalesGetActivationReportExportComplete = (payload) => {
     return {
          type: retailSalesConstants.RETAIL_SALES_GET_ACTIVATION_REPORT_EXPORT_COMPLETE,
          payload,
     };
};

export const retailSalesClearActivationReportExport = () => {
     return {
          type: retailSalesConstants.RETAIL_SALES_CLEAR_ACTIVATION_REPORT_EXPORT,
     };
};

export const retailSalesGetWinnerFilterOptionsRequest = (payload) => {
     return {
          type: retailSalesConstants.RETAIL_SALES_GET_WINNER_FILTER_OPTIONS_REQUEST,
          payload,
     };
};

export const retailSalesGetWinnerFilterOptionsComplete = (payload) => {
     return {
          type: retailSalesConstants.RETAIL_SALES_GET_WINNER_FILTER_OPTIONS_COMPLETE,
          payload,
     };
};

export const retailSalesGetWinnerVouchersRequest = (payload) => {
     return {
          type: retailSalesConstants.RETAIL_SALES_GET_WINNER_VOUCHERS_REQUEST,
          payload,
     };
};

export const retailSalesGetWinnerVouchersComplete = (payload) => {
     return {
          type: retailSalesConstants.RETAIL_SALES_GET_WINNER_VOUCHERS_COMPLETE,
          payload,
     };
};

export const retailSalesClearWinnerVouchers = () => {
     return {
          type: retailSalesConstants.RETAIL_SALES_CLEAR_WINNER_VOUCHERS,
     };
};

export const retailSalesResendActivationRequest = (payload) => {
     return {
          type: retailSalesConstants.RETAIL_SALES_RESEND_ACTIVATION_REQUEST,
          payload,
     };
};

export const retailSalesResendActivationComplete = (payload) => {
     return {
          type: retailSalesConstants.RETAIL_SALES_RESEND_ACTIVATION_COMPLETE,
          payload,
     };
};

export const retailSalesAddWinnersRequest = (payload) => {
     return {
          type: retailSalesConstants.RETAIL_SALES_ADD_WINNERS_REQUEST,
          payload,
     };
};

export const retailSalesAddWinnersComplete = (payload) => {
     return {
          type: retailSalesConstants.RETAIL_SALES_ADD_WINNERS_COMPLETE,
          payload,
     };
};

export const retailSalesClearAddWinnersResult = () => {
     return {
          type: retailSalesConstants.RETAIL_SALES_CLEAR_ADD_WINNERS_RESULT,
     };
};

export const retailSalesUpdateWinnerRequest = (payload) => {
     return {
          type: retailSalesConstants.RETAIL_SALES_UPDATE_WINNER_REQUEST,
          payload,
     };
};

export const retailSalesUpdateWinnerComplete = (payload) => {
     return {
          type: retailSalesConstants.RETAIL_SALES_UPDATE_WINNER_COMPLETE,
          payload,
     };
};

export const retailSalesClearUpdateWinnerResult = () => {
     return {
          type: retailSalesConstants.RETAIL_SALES_CLEAR_UPDATE_WINNER_RESULT,
     };
};

export const retailSalesGetDealersRequest = (payload) => {
     return {
          type: retailSalesConstants.RETAIL_SALES_GET_DEALERS_REQUEST,
          payload,
     };
};

export const retailSalesGetDealersComplete = (payload) => {
     return {
          type: retailSalesConstants.RETAIL_SALES_GET_DEALERS_COMPLETE,
          payload,
     };
};

export const retailSalesSaveDealersRequest = (payload) => {
     return {
          type: retailSalesConstants.RETAIL_SALES_SAVE_DEALERS_REQUEST,
          payload,
     };
};

export const retailSalesSaveDealersComplete = (payload) => {
     return {
          type: retailSalesConstants.RETAIL_SALES_SAVE_DEALERS_COMPLETE,
          payload,
     };
};

export const retailSalesClearSaveDealersResult = () => {
     return {
          type: retailSalesConstants.RETAIL_SALES_CLEAR_SAVE_DEALERS_RESULT,
     };
};

export const retailSalesDealerLookupRequest = (payload) => {
     return {
          type: retailSalesConstants.RETAIL_SALES_DEALER_LOOKUP_REQUEST,
          payload,
     };
};

export const retailSalesDealerLookupComplete = (payload) => {
     return {
          type: retailSalesConstants.RETAIL_SALES_DEALER_LOOKUP_COMPLETE,
          payload,
     };
};

export const retailSalesDealerListRequest = (payload) => {
     return {
          type: retailSalesConstants.RETAIL_SALES_DEALER_LIST_REQUEST,
          payload,
     };
};

export const retailSalesDealerListComplete = (payload) => {
     return {
          type: retailSalesConstants.RETAIL_SALES_DEALER_LIST_COMPLETE,
          payload,
     };
};

export const retailSalesGetJobTitlesRequest = (payload) => {
     return {
          type: retailSalesConstants.RETAIL_SALES_GET_JOB_TITLES_REQUEST,
          payload,
     };
};

export const retailSalesGetJobTitlesComplete = (payload) => {
     return {
          type: retailSalesConstants.RETAIL_SALES_GET_JOB_TITLES_COMPLETE,
          payload,
     };
};

export const retailSalesSaveJobTitlesRequest = (payload) => {
     return {
          type: retailSalesConstants.RETAIL_SALES_SAVE_JOB_TITLES_REQUEST,
          payload,
     };
};

export const retailSalesSaveJobTitlesComplete = (payload) => {
     return {
          type: retailSalesConstants.RETAIL_SALES_SAVE_JOB_TITLES_COMPLETE,
          payload,
     };
};

export const retailSalesClearSaveJobTitlesResult = () => {
     return {
          type: retailSalesConstants.RETAIL_SALES_CLEAR_SAVE_JOB_TITLES_RESULT,
     };
};

export const retailSalesDeleteJobTitleRequest = (payload) => {
     return {
          type: retailSalesConstants.RETAIL_SALES_DELETE_JOB_TITLE_REQUEST,
          payload,
     };
};

export const retailSalesDeleteJobTitleComplete = (payload) => {
     return {
          type: retailSalesConstants.RETAIL_SALES_DELETE_JOB_TITLE_COMPLETE,
          payload,
     };
};
